// extracted by mini-css-extract-plugin
module.exports = {"buttonTabGroup":"TabGroup-module--buttonTabGroup--2yFrr","lightButtonTabGroup":"TabGroup-module--lightButtonTabGroup--2_pAv"};